import { useRef } from "react";
import PaymentOverlays from "../../components/PaymentOverlays/PaymentOverlays";
import { PlayerSection } from "../../components/PlayerSearchResult";
import { useGiftFlow, useProductPayment } from "../../hooks";
import type { ShopItem, VipStatus } from "../../types";
import ChooseProduct from "./ChooseProduct";
import SearchPlayer from "./SearchPlayer";
import styles from "./styles.module.css";

export function Gifts() {
  const {
    currentStep,
    setCurrentStep,
    targetUser,
    prefillPlayerId,
    highlight,
    setHighlight,
    isAutoFetching,
    cameFromDirectLink,
    handlePlayerChange,
    resetPlayer,
    selectProduct,
    markDirectLinkHandled,
  } = useGiftFlow();

  const payment = useProductPayment();
  const preloadedPlayerRef = useRef<HTMLDivElement>(null);

  function handlePreloadedPlayerReady() {
    if (!cameFromDirectLink) return;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        preloadedPlayerRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
        markDirectLinkHandled();
      });
    });
  }

  function handleShopItemClick(product: ShopItem, vipStatus: VipStatus | null) {
    if (!targetUser) return;
    selectProduct(product, vipStatus);
    payment.openMethodSelector(product, targetUser.id);
  }

  return (
    <>
      {currentStep === 0 && (
        <div className={styles.selectform}>
          <SearchPlayer
            onPlayerChange={handlePlayerChange}
            highlight={highlight}
            onHighlightInput={() => setHighlight(false)}
            onStepChange={setCurrentStep}
            isAutoFetching={isAutoFetching}
            prefillPlayerId={prefillPlayerId}
          />
        </div>
      )}

      {currentStep === 1 && targetUser && (
        <div ref={preloadedPlayerRef} className={styles.selectform}>
          <PlayerSection data={targetUser} resetPlayer={resetPlayer} />
        </div>
      )}

      {currentStep === 1 && targetUser && (
        <ChooseProduct
          userId={targetUser.id}
          onShopItemClick={handleShopItemClick}
          shouldAutoScrollToPreloadedPlayer={cameFromDirectLink}
          onPreloadedPlayerReady={handlePreloadedPlayerReady}
        />
      )}

      <PaymentOverlays
        isMethodSelectorOpen={payment.isMethodSelectorOpen}
        isCardOverlayOpen={payment.isCardOverlayOpen}
        isPaymentStarting={payment.isPaymentStarting}
        paymentError={payment.paymentError}
        cardPaymentKey={payment.cardPaymentKey}
        closeMethodSelector={payment.closeMethodSelector}
        closePaymentOverlay={payment.closePaymentOverlay}
        startCardPayment={payment.startCardPayment}
        startSbpPayment={payment.startSbpPayment}
      />
    </>
  );
}
